import React, {useCallback} from 'react';
import {CreateEditITControlModal} from '@ey/canvascoreservices';
import {useDispatch, useSelector} from 'react-redux';
import {currentResource, labels} from '../../../util/utils';
import {createITControl, getITControlById, updateITControl} from '../../../actions/ITControl/itcontrolaction';
import {getAllItProcessesWithoutPagination} from '../../../actions/ITProcess/itprocessactions';
import {updateRelatedObject} from '../../../actions/RelatedObjects/relatedobjectsactions';
import {updateFormBodyRelatedObject} from '../../../actions/FormData/formdataactions';
import Utility from '../../../util/utilityfunctions';

export default function CreateEditITControlModalWrapper(props) {
	const {
		isITGC,
		bodyId,
		documentId,
		entityId,
		isCreate,
		isEdit,
		showModal,
		setShowModal,
		onClose,
		entityType,
		viewOnly = false,
		itProcessId,
		itProcessName,
		parentEntityId,
		parentEntityName,
		onItControlUpdated
	} = props;

	const config = {
		controlEffectivenessType: currentResource.controlEffectivenessType,
		controlFrequencyType: currentResource.controlFrequencyType,
		designEffectivenessType: currentResource.designEffectivenessType,
		testing: currentResource.testing
	};

	if (isITGC) {
		config.labels = currentResource.EntitiesLabels[entityType].ITGC;
	} else {
		config.labels = currentResource.EntitiesLabels[entityType].ITSP;
	}

	const engagementId = Number(useSelector((state) => state.engagementId));
	const {itProcesses, itControlDetails} = useSelector((store) => {
		const itProcesses = [];
		for (const process of Object.values(store.bodiesSpecial.itProcesses.byId)) {
			if (process.engagementId === engagementId) {
				itProcesses.push({
					value: process.id,
					label: process.itProcessName,
					itRisks: process.itRisks.map((itRiskId) => store.bodiesSpecial.itRisks.byId[itRiskId]),
					itControls: process.itControls
				});
			}
		}
		return {
			itProcesses,
			itControlDetails: store.bodiesSpecial.itControls?.byId[entityId]
		};
	});

	const getItProcessesWithoutPagination = () =>
		dispatch(
			getAllItProcessesWithoutPagination(engagementId, null, {
				includePagination: false,
				includeITRisk: true,
				includeITControl: true
			})
		);

	const handleOnItControlUpdated = useCallback(
		(itControl) => {
			let promise = Promise.resolve();

			if (onItControlUpdated) {
				promise = onItControlUpdated(itControl);
			}

			return promise;
		},
		[onItControlUpdated]
	);

	const dispatch = useDispatch();

	return (
		<>
			{isCreate && (
				<CreateEditITControlModal
					engagementId={Number(engagementId)} //
					showModal={showModal} //
					setShowModal={setShowModal} //
					labels={config.labels}
					createITControlAction={(engagementId, payload, itProcessId) => {
						return dispatch(createITControl(engagementId, payload, itProcessId));
					}}
					itProcesses={itProcesses}
					itControlDetails={itControlDetails}
					getAllItProcessesWithoutPagination={getItProcessesWithoutPagination}
					updateFormBodyRelatedObject={(formBodyRelatedObject) => {
						dispatch(updateFormBodyRelatedObject(formBodyRelatedObject));
					}}
					updateRelatedObject={(relatedObject) => {
						dispatch(updateRelatedObject(relatedObject));
					}}
					onClose={onClose}
					controlEffectivenessType={config.controlEffectivenessType}
					controlFrequencyType={config.controlFrequencyType}
					designEffectivenessType={config.designEffectivenessType}
					testing={config.testing}
					isITGC={isITGC}
					charactersLabel={labels.characters}
					ofLabel={labels.of}
					itProcessId={itProcessId}
					itProcessName={itProcessName}
					parentEntityId={parentEntityId}
					parentEntityName={parentEntityName}
					theme={Utility.getTheme()}
				/>
			)}
			{isEdit && (
				<CreateEditITControlModal
					engagementId={Number(engagementId)}
					showModal={showModal}
					setShowModal={setShowModal}
					labels={config.labels}
					updateITControlAction={(payload, itProcessId, entityId) => {
						return dispatch(updateITControl(engagementId, entityId, payload)).then((itControl) =>
							handleOnItControlUpdated(itControl)
						);
					}}
					getITControlById={() => {
						return dispatch(getITControlById(engagementId, entityId, documentId));
					}}
					itControlId={entityId}
					isITGC={isITGC}
					itProcesses={itProcesses}
					itControlDetails={itControlDetails}
					getAllItProcessesWithoutPagination={getItProcessesWithoutPagination}
					updateFormBodyRelatedObject={(formBodyRelatedObject) =>
						dispatch(updateFormBodyRelatedObject(formBodyRelatedObject))
					}
					updateRelatedObject={(relatedObject) => {
						dispatch(updateRelatedObject(relatedObject));
					}}
					onClose={onClose}
					controlEffectivenessType={config.controlEffectivenessType}
					controlFrequencyType={config.controlFrequencyType}
					designEffectivenessType={config.designEffectivenessType}
					testing={config.testing}
					viewOnly={viewOnly}
					charactersLabel={labels.characters}
					ofLabel={labels.of}
					theme={Utility.getTheme()}
				/>
			)}
		</>
	);
}
